/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { ButtonListProps } from './ButtonList.props';

/**
 * SDS ButtonList component.
 */
export const ButtonList = (props: ButtonListProps): JSX.Element => {
  const { buttonKeys, buttons, buttonsPosition, classes, isWide, ...rest } = props;

  const buttonListClass = clsx(`sds-button-list`, classes, {
    [`button-list--wide`]: isWide,
    [`button-list--${buttonsPosition}`]: buttonsPosition,
  });

  const getButtons = (): Array<JSX.Element> => {
    return buttons.map((button, index): JSX.Element => {
      return <li key={buttonKeys[index]}>{button}</li>;
    });
  };

  if (buttons.length > 0) {
    return (
      <ul className={buttonListClass} {...rest}>
        {getButtons()}
      </ul>
    );
  }

  return <></>;
};
